import React from 'react';
import { ArrowUp, ArrowDown } from 'lucide-react';
import { cn } from '../../lib/utils';

/**
 * StatCard — DESIGN_SYSTEM.md §6.
 * Uppercase label, 30/700 number, optional delta. The primary card uses an
 * indigo-tint background + indigo number.
 */
export type StatCardProps = {
  label: string;
  value: React.ReactNode;
  delta?: { value: string; up?: boolean };
  primary?: boolean;
  className?: string;
};

export function StatCard({ label, value, delta, primary, className }: StatCardProps) {
  return (
    <div
      className={cn(
        'rounded-card border p-5',
        primary ? 'border-transparent bg-indigo-tint' : 'border-hairline bg-background',
        className,
      )}
    >
      <div
        className={cn(
          'text-[11.5px] font-semibold uppercase tracking-[0.06em]',
          primary ? 'text-indigo' : 'text-ink-2',
        )}
      >
        {label}
      </div>
      <div className="mt-2 flex items-end justify-between gap-2">
        <div
          className={cn(
            'text-[30px] font-bold leading-none',
            primary ? 'text-indigo' : 'text-ink',
          )}
        >
          {value}
        </div>
        {delta && (
          <div
            className={cn(
              'mb-1 inline-flex items-center gap-0.5 text-[13px] font-semibold',
              delta.up ? 'text-success' : 'text-ink-2',
            )}
          >
            {delta.up ? <ArrowUp className="size-3.5" /> : <ArrowDown className="size-3.5" />}
            {delta.value}
          </div>
        )}
      </div>
    </div>
  );
}

export function StatRow({ children }: { children: React.ReactNode }) {
  return <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">{children}</div>;
}
